import { render, staticRenderFns } from "./TemplateEditTabInformation.vue?vue&type=template&id=10577fa7&"
import script from "./TemplateEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./TemplateEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports